<template>
  <header
    class="hero-default pt-nav relative flex h-screen flex-col flex-wrap lg:h-[80vh] lg:flex-row xl:h-[73vh]"
  >
    <div
      class="flex h-auto w-full flex-1 overflow-hidden bg-amber-100 md:flex-2 lg:flex-1 xl:h-full xl:w-1/2 xl:flex-auto"
    >
      <ClientOnly v-if="data.file && data.file.extension === 'json'">
        <Vue3Lottie
          :animation-link="data.file.url"
          :renderer-settings="{
            preserveAspectRatio: 'xMaxYMid slice',
          }"
          class="pointer-events-none w-full"
        />
      </ClientOnly>

      <AppImage v-else :src="data.file" class="h-full object-cover" />
    </div>

    <div
      class="w-full flex-1 text-white blue:bg-blue-500 green:bg-green-500 pink:bg-pink-500 xl:w-1/2 xl:flex-auto"
    >
      <Container
        indent="container-tight"
        class="flex h-full flex-col pt-12 lg:justify-end lg:px-16 lg:pb-20"
      >
        <p
          v-if="parentPage && parentPage.parent"
          class="mb-4 text-3xs font-semibold uppercase xl:text-2xs"
        >
          <!-- eslint-disable-next-line -->
        <span v-if="parentPage.parent.url !== '/'">{{ parentPage.parent.title }} – </span>{{ parentPage.title }}
        </p>
        <h1
          class="hyphens-auto max-w-6xl text-xl font-medium lg:text-4xl xl:text-5xl"
        >
          {{ data.heading }}
        </h1>
      </Container>
    </div>

    <Floater :link="data.link" :link-text="data.link_text" />
  </header>
</template>

<script setup>
defineProps({
  data: {
    type: Object,
    required: true,
  },
  parentPage: { type: Object, default: null },
})
</script>

<style>
.hero-default .lottie-animation-container svg {
  transform: scale(1.115) !important;
  transform: 11.5% 11.5%;
}
</style>
